import React, { useState, useEffect, useRef } from 'react';
import useNetworkStatus from '../../hooks/useNetworkStatus';
import config from '../../config';
import '../../styles/network-status.css';

/**
 * Thin amber bar at top of viewport when offline.
 * Position: fixed overlay — does NOT push content down.
 */
const NetworkStatus = () => {
  const { isOnline } = useNetworkStatus();
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!isOnline) {
      setVisible(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    } else if (visible) {
      // Delay hide to let user notice reconnection
      timeoutRef.current = setTimeout(
        () => setVisible(false),
        config.pwa.offlineReconnectDelay
      );
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline]);

  if (!visible) return null;

  return (
    <div
      className={`network-status ${isOnline ? 'network-status--reconnecting' : 'network-status--offline'}`}
      role="status"
      aria-live="polite"
    >
      {isOnline ? 'Back online' : "You're offline \u2014 showing cached data"}
    </div>
  );
};

export default NetworkStatus;
